import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as lmsAction from "../../../redux/actions/lmsAction";
import AddLesson from "../component/addLesson/addLessons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LESSON,
  DASHBOARD,
  ACCESS_DENIED,
} from "../../../constant/routeContant";
import SuccessScreencommon from "../../../library/custom/success/successScreen";
import { API_STATUS } from "../../../constant/constant";
import Loader from "../../../library/common/Loader";
import { checkPrivileges } from "../../../utils/rolesHelper";
import * as quizAction from "../../../redux/actions/quizAction";

const AddLessonsContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const edit = pathname.split("/")[2] ?? null;
  const editid = pathname.split("/")[3] ?? null;
  const quizId = location?.state?.quizDetailsData?.data?.quizId;
  const isLessonEditMode = location?.state?.isLessonEditMode;
  const isQuiz = location?.state?.isQuiz;
  const quizDetails = location?.state?.quizDetailsData?.data;
  const updateQuiz = useSelector((state) => state.updateQuiz);
  const isLoadingUpdate = updateQuiz?.isLoading;
  const [successScreens, setSuccessScreens] = useState(false);
  let navigate = useNavigate();
  const isCloneOf = location.state?.isCloneOf;
  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10]);
    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    dispatch(lmsAction.createLessonClear());
    dispatch(lmsAction.clearDeleteLesson(""));
  }, []);
  const categoryListDataIsloading = useSelector(
    (state) => state.getCategoryList?.isLoading
  );
  const categoryListData = useSelector((state) => state.getCategoryList?.data);
  const createLesson = useSelector((state) => state.createLesson);
  const statuss = createLesson?.status;
  const cid = createLesson?.data?.lessonId;
  const lessdetail = useSelector((state) => state.updateLesson);
  const statussss = lessdetail?.status;
  const lessonDetailData = lessdetail?.editLessonData;
  const isLoading = useSelector((state) => state.updateLesson?.isLoading);
  const isLoadingAdd = useSelector((state) => state.createLesson?.isLoading);
  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10]);

    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    if (!!edit && editid) {
      dispatch(lmsAction.getLessonDetails(editid));
    }
  }, [edit, editid, dispatch]);

  const addAndUpdateLesson = async (data) => {
    setSuccessScreens(true);
    if (editid || isLessonEditMode) {
      if (quizId > 0 && isQuiz) {
        const data = quizDetails
          ? {
              quizId: quizDetails.quizId ?? 0,
              organisationId: localStorage.getItem("orgId"),
              lessonId: quizDetails?.lessonId || "",
              createdBy: localStorage.getItem("userId") ?? "",
              title: quizDetails?.title ?? "",
              description: quizDetails?.description ?? "",
              passPercentage: quizDetails?.passPercentage,
              questions:
                quizDetails?.questions?.map((q) => ({
                  // questionId: q?.id ?? 0,
                  question: q?.question ?? "",
                  isFileAdded: q?.isFileAdded ?? false,
                  answers:
                    q?.answers?.map((ans) => ({
                      answerId: ans?.answerId ?? 0,
                      answer: ans?.answer || "",
                      isCorrected: ans?.isCorrected ?? false,
                    })) || [],
                  fileIds: q?.fileIds?.length > 0 ? q.fileIds : [],
                })) || [],
            }
          : {};
        dispatch(quizAction.updateQuizList({ data }));
      } else {
        if (quizId == 0) {
          const data = quizDetails
            ? {
                quizId: quizDetails.quizId ?? 0,
                organisationId: localStorage.getItem("orgId"),
                lessonId: quizDetails?.lessonId || "",
                createdBy: localStorage.getItem("userId") ?? "",
                title: quizDetails?.title ?? "",
                description: quizDetails?.description ?? "",
                passPercentage: quizDetails?.passPercentage,
                questions:
                  quizDetails?.questions?.map((q) => ({
                    // questionId: q?.id ?? 0,
                    question: q?.question ?? "",
                    isFileAdded: q?.isFileAdded ?? false,
                    answers:
                      q?.answers?.map((ans) => ({
                        answerId: ans?.answerId ?? 0,
                        answer: ans?.answer || "",
                        isCorrected: ans?.isCorrected ?? false,
                      })) || [],
                    fileIds: q?.fileIds?.length > 0 ? q.fileIds : [],
                  })) || [],
              }
            : {};
          dispatch(quizAction.createQuiz({ data }));
        }
      }
      const { quiz, ...updatePayload } = data;
      dispatch(lmsAction.updateLessonsData(updatePayload));
    } else {
      const { lessonId, DynamicFields, ...addPayload } = data;
      const updatedDynamicFields = DynamicFields.map(
        ({ sectionId, ...rest }) => rest
      );
      const finalPayload = {
        ...addPayload,
        DynamicFields: updatedDynamicFields,
      };

      dispatch(lmsAction.createLesson(finalPayload));
    }
  };

  const successScree = (id, message, labelmsg) => {
    return (
      <SuccessScreencommon
        isUpdate={message}
        route={LESSON}
        id={id}
        label2={labelmsg}
        label1="Lesson ID"
        label4="Lesson in"
      ></SuccessScreencommon>
    );
  };

  return (
    <>
      {isLoading || (isLoadingAdd && <Loader />)}
      {isLoading && <Loader />}
      {categoryListDataIsloading && <Loader />}
      {statuss === API_STATUS.SUCCESS && !editid && successScreens ? (
        successScree(cid, "Lesson Created Successfully", "")
      ) : statussss === API_STATUS.SUCCESS &&
        (editid || lessdetail?.data?.lessonId) &&
        successScreens ? (
        successScree(
          editid || lessdetail?.data?.lessonId,
          "Lesson Updated Successfully",
          "has been updated"
        )
      ) : (
        <AddLesson
          categoryListData={categoryListData}
          onSubmit={addAndUpdateLesson}
          lessonDetailData={lessonDetailData}
          isCloneOf={isCloneOf}
          quizId={quizId}
          isLessonEditMode={isLessonEditMode}
        />
      )}
    </>
  );
};
export default AddLessonsContainer;
